<template>
  <b-modal
    id="product-creation-prompt"
    hide-header
    centered
    body-class="p-4"
    content-class="p-0"
    footer-class="pt-2 border-top justify-content-end"
  >
    <strong> {{ title }} </strong>
    <p>{{ message }}</p>
    <template slot="modal-footer">
      <b-button
        v-for="(button, index) in buttons"
        :key="index"
        :variant="button.variant"
        @click="doAction(button.type)"
        :disabled="loading"
      >
        {{ button.label }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      title: null,
      message: null,
      buttons: []
    }
  },
  computed: {
    ...mapState("estoreInventories", ["loading"]),
  },
  mounted() {
    this.$root.$on("bv::show::modal", (id, payload) => {
      if (id === "product-creation-prompt") {
        this.title = payload.title;
        this.message = payload.message;
        this.buttons = payload.buttons;
      }
    })
  },
  methods: {
    close() {
      this.$root.$emit("bv::hide::modal", "product-creation-prompt");
    },
    leave() {
      this.$router.go(-1);
    },
    save() {
      this.$root.$emit("saveProductCreation", this.is_draft);
    },
    doAction(type) {
      this[type]();
    }
  }
}
</script>
